import {
  StudentIcon,
  // ParentIcon,
  // TeacherIcon,
  SchoolRepresentativeIcon,
} from "../../components/AscIcons";

export const DEFAULT_USER_TYPES = [
  { label: "Student", value: "STUDENT", icon: <StudentIcon /> },
  // { label: "Teacher", value: "TEACHER", icon: <TeacherIcon /> },
  // Parent role is not supported yet
  // { label: "Parent", value: "PARENT", icon: <ParentIcon /> },
  {
    label: "Organization representative",
    value: "SCHOOL",
    icon: <SchoolRepresentativeIcon />,
  },
] as const;
